export default "__VITE_ASSET__qTWOL6we__"